import React from 'react';
import { Box, Typography, CircularProgress, Paper, Container } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import { green } from '@mui/material/colors';

const RegistroExitoso = () => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          mt: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%'
          }}
        >
          <CheckCircleOutline
            sx={{
              fontSize: 60,
              color: green[500],
              mb: 2
            }}
          />
          <Typography variant="h5" component="h1" gutterBottom align="center">
            ¡Registro Exitoso!
          </Typography>
          <Typography variant="body1" align="center" sx={{ mb: 2 }}>
            Tu cuenta ha sido creada correctamente
          </Typography>
          <Box sx={{ mt: 2, display: 'flex', alignItems: 'center' }}>
            <CircularProgress size={20} sx={{ mr: 1 }} />
            <Typography variant="body2" color="text.secondary">
              Redirigiendo al inicio de sesión...
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default RegistroExitoso; 